import React from "react";
const SvgError = props => (
  <svg viewBox="0 0 19 19" {...props}>
    <g fill="none">
      <rect
        width={2.25}
        height={8.25}
        x={8.25}
        y={4.88}
        fill="#FFF"
        rx={1.13}
      />
      <circle cx={9.38} cy={14.63} r={1.13} fill="#FFF" />
      <path
        fill="#000"
        d="M10.196 11.977a.82.82 0 11-1.641 0V5.771a.82.82 0 111.64 0v6.206zm-.82 2.045a.82.82 0 110 1.64.82.82 0 010-1.64zm9.043.396L11.517 1.877C11 .936 9.914.376 8.713.66c-.64.153-1.172.616-1.494 1.201L.317 14.401c-.54.98-.414 2.284.555 3.199.417.392.996.565 1.565.565h13.82c1.038 0 2.032-.668 2.397-1.847.195-.632.082-1.323-.235-1.9z"
      />
    </g>
  </svg>
);
export default SvgError;
